module.exports = __webpack_public_path__ + "img/logo_astek.78c8b7aa.png";